import PromisedResource from './PromisedResource'

export default class ClientExclusionRulesResource extends PromisedResource {
  constructor({ remote, client }) {
    super(remote.query(q => q.findRelatedRecords(client, 'exclusionRules')))
  }
}
